import React, { useState, useEffect, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Grid, Box } from '@material-ui/core';
import clsx from 'clsx';
import GitHubLogin from './GitHubLogin';
import SimpleLogin from './SimpleLogin';
import AuthContext from '../AppAuthContext';
import '../../styling/Styles.css';

/**
 * This component handle the login page.
 */

const Login = () => {
  const { state, dispatch } = useContext(AuthContext);
  const [data, setData] = useState({ errorMessage: '', isLoading: '' });

  /**
   * This effect is responsible to check the redirection from server
   * and save the user profile, which holds the access token. As of now
   * (2/3/2021) the user is saved in localStorage and as cookie
   *
   */
  useEffect(() => {
    if (window.location.href.includes('accessToken=')) {
      const callBackResp = window.location.href.split(/[?&]/);
      window.history.pushState({}, null, callBackResp[0]);
      callBackResp.shift();

      const user = {};
      callBackResp.forEach( value => {
        const splittedValue = value.split(/=/);
        user[splittedValue[0]] = decodeURIComponent(splittedValue[1]);
      })


      dispatch({
        type: 'LOGIN',
        payload: {
          user,
          isLoggedIn: true
        }
      });
    }
  });

  /**
   * this effect catches a error and stops the loading procedure
   */
  useEffect(() => {
    if (window.location.href.includes('?error=')) {
      setData({ isLoading: false, errorMessage: 'Sorry! Login failed' });
    }
  }, []);

  if (state.isLoggedIn) {
    return <Navigate to="/" />;
  }
  
  {/* Simple login functionality is commented. Uncomment to use it */}
  return (
    <div className={clsx('backgroundBlueColor')}>
      <Grid container alignItems="center" style={{ marginTop: '25vh' }} direction="column">
        <Grid item>
          <Box display="flex">
            <img src='/images/General/Wabli_white_logo.png' alt="logo" className={clsx('loginLogoStyle')} />
          </Box>
        </Grid>
        <Grid item style={{ marginTop: '2vh' }}>
          <Box className={clsx('greyTable')}>
            <WelcomeSign />
            <GitHubLogin data={data} setData={setData} />
            {data.isLoading !== true && (
              <SimpleLogin data={data} setData={setData} dispatch={dispatch} />
            )}
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

const WelcomeSign = () => (
  <>
    <Box mt={2} display="flex">
      <div
        style={{
          fontSize: '3vw',
          width: '15vw',
          whiteSpace: 'nowrap',
          textAlign: 'center'
        }}
        className={('parent', clsx('marginAuto', 'lightBlue'))}
      >
        WELCOME
      </div>
    </Box>
    <Box display="flex">
      <div
        style={{
          fontSize: '1.75vw',
          width: '15vw',
          whiteSpace: 'nowrap'
        }}
        className={clsx('marginAuto', 'lightBlue')}
      >
        to WABLI platform
      </div>
    </Box>
  </>
);

export default Login;
